
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
  font-family: var(--ff-display);
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* unset browser defaults for headings and p */
:host:is(h1,h2,h3,h4,h5,h6,p),
h1,h2,h3,h4,h5,h6 {
  all: unset;
}
/* Image reset */
img {
  max-width: 100%;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.sr-only,
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  display:block;
  position:relative;
  height:100%;
  --sic-body-text--font-size:var(--sic-card-tile--default--text-font-size);
  --sic-body-text--line-height:var(--sic-card-tile--default--text-line-height);
}
.card-wrapper{
  background-color:var(--sic-card-tile--default--background-color);
  background-color:var(
    --sic-card-tile--background-color,
    var(--sic-card-tile--default--background-color)
  );
  border-color:var(--sic-card-tile--default--border-color);
  border-color:var(
    --sic-card-tile--border-color,
    var(--sic-card-tile--default--border-color)
  );
  border-width:var(--sic-card-tile--default--border-width);
  border-width:var(
    --sic-card-tile--border-width,
    var(--sic-card-tile--default--border-width)
  );
  border-style:solid;
  border-radius:var(--sic-card-tile--default--border-radius);
  border-radius:var(
    --sic-card-tile--border-radius,
    var(--sic-card-tile--default--border-radius)
  );
  height:100%;
}
.card-image{
  display:block;
  overflow:hidden;
  position:relative;
}
.card-image picture{
    display:flex;
  }
.card-image img{
    max-width:100%;
    height:auto;
    aspect-ratio:auto;
  }
.card-icon{
  color:var(--sic-card-tile--default--icon-color);
  color:var(
    --sic-card-tile--icon-color,
    var(--sic-card-tile--default--icon-color)
  );
  display:block;
  padding:var(--sic-card-tile--default--content-padding);
  padding:var(
    --sic-card-tile--content-padding,
    var(--sic-card-tile--default--content-padding)
  );
  padding-bottom:var(--spacing-02);
}
.card-icon sic-icon{
    --icon-size:var(
      --sic-card-tile--icon-width,
      var(--sic-card-tile--default--icon-width)
    );
    display:inline-block;
    width:var(--sic-card-tile--default--icon-width);
    width:var(
      --sic-card-tile--icon-width,
      var(--sic-card-tile--default--icon-width)
    );
  }
.card-content{
  background-color:var(--sic-card-tile--default--background-color);
  background-color:var(
    --sic-card-tile--background-color,
    var(--sic-card-tile--default--background-color)
  );
  border-radius:var(--sic-card-tile--default--border-radius);
  border-radius:var(
    --sic-card-tile--border-radius,
    var(--sic-card-tile--default--border-radius)
  );
  padding:var(--sic-card-tile--default--content-padding);
  padding:var(
    --sic-card-tile--content-padding,
    var(--sic-card-tile--default--content-padding)
  );
}
.eyebrow{
  font-size:var(--sic-card-tile--default--eyebrow-font-size);
  font-size:var(
    --sic-card-tile--eyebrow-font-size,
    var(--sic-card-tile--default--eyebrow-font-size)
  );
  line-height:var(--sic-card-tile--default--eyebrow-line-height);
  line-height:var(
    --sic-card-tile--eyebrow-line-height,
    var(--sic-card-tile--default--eyebrow-line-height)
  );
  margin-bottom:var(--spacing-02);
}
.heading{
  --sic-text-color:var(
    --sic-card-tile--text-color,
    var(--sic-card-tile--default--text-color)
  );

  color:var(--sic-card-tile--default--text-color);

  color:var(
    --sic-card-tile--text-color,
    var(--sic-card-tile--default--text-color)
  );
  font-size:var(--sic-card-tile--default--heading-font-size);
  font-size:var(
    --sic-card-tile--heading-font-size,
    var(--sic-card-tile--default--heading-font-size)
  );
  line-height:var(--sic-card-tile--default--heading-line-height);
  line-height:var(
    --sic-card-tile--heading-line-height,
    var(--sic-card-tile--default--heading-line-height)
  );
}
.heading a{
    color:var(--sic-card-tile--default--text-color);
    color:var(
      --sic-card-tile--text-color,
      var(--sic-card-tile--default--text-color)
    );
    text-decoration:none;
  }
.heading a:focus-visible{
      outline:none;
    }
.heading h2,
  .heading h3,
  .heading h4,
  .heading h5,
  .heading h6,
  .heading p,
  .heading div{
    font-size:var(--sic-card-tile--default--heading-font-size);
    font-size:var(
      --sic-card-tile--heading-font-size,
      var(--sic-card-tile--default--heading-font-size)
    );
    font-weight:var(--fw-bold);
    line-height:var(--sic-card-tile--default--heading-line-height);
    line-height:var(
      --sic-card-tile--heading-line-height,
      var(--sic-card-tile--default--heading-line-height)
    );
    margin:0;
  }
.description{
  font-size:var(--body-01-font-size);
  font-size:var(--sic-body-text--font-size, var(--body-01-font-size));
  line-height:var(--body-01-line-height);
  line-height:var(--sic-body-text--line-height, var(--body-01-line-height));
  font-weight:var(--fw-normal);
  padding-top:var(--sic-card-tile--default--text-padding-top);
  padding-top:var(
    --sic-card-tile--text-padding-top,
    var(--sic-card-tile--default--text-padding-top)
  );
}
.cta{
  margin-top:var(--sic-card-tile--default--cta-margin-top);
  margin-top:var(
    --sic-card-tile--cta-margin-top,
    var(--sic-card-tile--default--cta-margin-top)
  );
}
.card-wrapper--with-image .card-image img{
      border-radius:var(--sic-card-tile--default--border-radius);
      border-radius:var(
        --sic-card-tile--border-radius,
        var(--sic-card-tile--default--border-radius)
      );
    }
`;